import React, { useState,useEffect  } from "react";
import { Button, Form, Input, Radio, Checkbox, Row, Col } from "antd";
import { framework_tool,component_tool } from '@/tool'
let { WizFileUpload } = framework_tool;
let { Wizmessage } = component_tool


const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const Task = ({ form, data, submit, cancel, checkList,resetNum, ...props }) => {

  // const [type, setType] = useState(data.fileType)
  const { getFieldDecorator, validateFields, setFields, resetFields, setFieldsValue,getFieldsValue } = form
  console.log(form, 'formformform')
  useEffect(() => {
    setFieldsValue({ state: data.state || 0, way: data.way||[], noticeWhitelist: data.noticeWhitelist || 0 })

  }, [resetNum])
  const _submit = (pass) => {
    validateFields((err, values) => {
      if (!err) {
        if (pass === 3) {
          submit && submit({ ...values }, 3,'task');
          // resetFields()
          return;
        } else {
          submit && submit({ ...values }, 2,'task');
          // resetFields()
        }
        Wizmessage.success('保存成功')
      }
    });
  }
  formatLink = ({ fileType, fileId, address }) => {
    let newFileId = getOssFilePath(fileId[0]?.fileId || '')
    let fileOriginalName = fileId[0]?.fileOriginalName || ''
    if (fileType == 0) {
      return <a href={newFileId}>
        {fileOriginalName}
      </a>
    } else {
      return address
    }
  }
  checkChange = () => {

  }
  const { state = 0, way = [], noticeWhitelist = 0 } = data || {}
  return (
    <>
      <Form {...formItemLayout}>
        <Form.Item label="是否添加到任务">
          {getFieldDecorator('state', {
            initialValue: state,
          })(<Radio.Group
          //   onChange={(e) => {
          //   console.log(e, 'value777')
          //   setType(e.target.value)
          // }} value={type}
          >
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>)
          }
        </Form.Item>
        {getFieldsValue().state==1?
         <Form.Item label="通知方式">
         {getFieldDecorator('way', {
           initialValue: way,
           rules: [{ required: true, message: '请勾选通知方式' }],
         })(<Checkbox.Group style={{ width: '100%' }}>
           <Row>
             {checkList?.length > 0 && checkList.map(item => {
               return (
                 <Col span={8}>
                   <Checkbox value={item.sceneName}>{item.sceneName}</Checkbox>
                 </Col>
               )
             })}
           </Row>
         </Checkbox.Group>,)
         }
       </Form.Item>:null}

        <Form.Item label="通知白名单">
          {getFieldDecorator('noticeWhitelist', {
            initialValue: noticeWhitelist,
          })(<Radio.Group
          //    onChange={(e) => {
          //   setType(e.target.value)
          // }} value={type}
          >
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>)
          }
        </Form.Item>
        <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
          <Button type='primary' onClick={() => _submit(2)}>保存</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={() => _submit(3)}>保存并关闭</Button>
        </Form.Item>
      </Form>
    </>
  )
}

let TaskForm = Form.create()(Task)
export {
  TaskForm,
}

